export default __webpack_public_path__ + "static/media/ux2.c446b74a.png";